import { blackCards } from "../constants/BlackCards";
import { Genders } from "../constants/Genders";
import { redCards } from "../constants/RedCard";
import { replacePronouns } from "./PronounsUtil";

export const getTimerText = (timeInSeconds: number) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    const secondsStr = seconds < 10 ? "0" + String(seconds) : String(seconds);
    return String(minutes) + ":" + String(secondsStr);
}

export const cutText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) {
        return text;
    }

    text = text.substring(0, maxLength - 1); // for example, if maxLength is 15, we want 14 chars left at the end
    text += "...";
    return text;
}

export const getRedCardText = (idx: number, criminalName: string, criminalGender: Genders) => {
    const cards = redCards;
    if (idx < cards.length) {
        let text = cards[idx];
        text = replacePronouns(text, criminalGender);
        text = criminalName + " " + text;
        return text;
    }
    return "";
}
  
export const getBlackCardText = (idx: number, criminalName: string, criminalGender: Genders) => {
    var cards = blackCards;
    if (idx < cards.length) {
        let text = cards[idx];
        text = replacePronouns(text, criminalGender);
        text = criminalName + " " + text;
        return text;
    }
    return "";
}